import { Map, List } from "immutable";

import {
  USER_PROFILE_LIST_REQUEST,
  USER_PROFILE_LIST_SUCCESS,
  USER_PROFILE_LIST_FAILURE,
} from "./actions";
import Logger from "../../../lib/Logger";

export default function userProfiles(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    "debug",
    `[userProfiles.reducers] userProfiles(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case USER_PROFILE_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case USER_PROFILE_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ["pages", action.order, action.limit, action.page],
          List(action.result)
        );

    case USER_PROFILE_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    default:
      return state;
  }
}

Logger.log("silly", `userProfiles.reducers loaded.`);
